import React from 'react';
import logo from '../../assets/brand/logo-horizontal.svg';

const AuthLayout = ({ title, subtitle, children }) => (
  <div className="auth-main relative">
    <div className="auth-wrapper v1 flex items-center w-full h-full min-h-screen">
      <div className="auth-form flex items-center justify-center grow flex-col min-h-screen relative p-6">
        <div className="w-full max-w-[350px] relative">
          <div className="auth-bg" aria-hidden="true">
            <span className="absolute top-[-100px] right-[-100px] w-[300px] h-[300px] block rounded-full bg-theme-bg-1 animate-[floating_7s_infinite]" />
            <span className="absolute top-[150px] right-[-150px] w-5 h-5 block rounded-full bg-primary-500 animate-[floating_9s_infinite]" />
            <span className="absolute left-[-150px] bottom-[150px] w-5 h-5 block rounded-full bg-theme-bg-1 animate-[floating_7s_infinite]" />
            <span className="absolute left-[-100px] bottom-[-100px] w-[300px] h-[300px] block rounded-full bg-theme-bg-2 animate-[floating_9s_infinite]" />
          </div>
          <div className="card sm:my-12 w-full shadow-none">
            <div className="card-body !p-10">
              <div className="text-center mb-8">
                <img src={logo} alt="CashAfrica" className="mx-auto h-10" />
              </div>
              <h4 className="text-center font-medium mb-4">{title}</h4>
              {subtitle && (
                <p className="text-center text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor mb-6">
                  {subtitle}
                </p>
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthLayout;
